export default {
    leftParenthesis: '{',
    rightParenthesis: '}',
    button: {
        run: 'Run',
        save: 'Save',
        cancel: 'Cancel'
    },
    menu:{
        dashboard: 'Dashboard',
        projects: 'Projects',
        formatter: 'Create JSON',
        pageModeler: 'Page modeler',
        addcomponents: 'Add component',
        about: 'About me',
        learn: 'Learn',
        inprogress: 'In progress',
        donate: 'Donate'
    }
}
